import api from 'api'

type WorkerListingSupplyAnalyticsResponse = {
  eligibleCount: number
  ineligibilityReasons: string[]
}

type GetWorkerListingSupplyAnalyticsParams = {
  workerId?: number | null
}

export async function getWorkerListingSupplyAnalytics(
  listingId: number,
  workerId?: number | null
) {
  const params: GetWorkerListingSupplyAnalyticsParams = {}
  if (workerId) {
    params.workerId = workerId
  }
  const response = await api.get<WorkerListingSupplyAnalyticsResponse>(
    `/admin/listing/${listingId}/supply_analytics`,
    params ? { params } : undefined
  )
  return response.data
}
